import {
  CUSTOMER_PRODUCT_RATING_LIST_REQUEST,
  CUSTOMER_PRODUCT_RATING_LIST_SUCCESS,
  CUSTOMER_PRODUCT_RATING_LIST_FAILURE,
  CUSTOMER_PRODUCT_RATING_LIKE_REQUEST,
  CUSTOMER_PRODUCT_RATING_LIKE_SUCCESS,
  CUSTOMER_PRODUCT_RATING_LIKE_FAILURE,
  CUSTOMER_PRODUCT_RATING_DISLIKE_REQUEST,
  CUSTOMER_PRODUCT_RATING_DISLIKE_SUCCESS,
  CUSTOMER_PRODUCT_RATING_DISLIKE_FAILURE,
  CUSTOMER_PRODUCT_RATING_DELETE_REQUEST,
  CUSTOMER_PRODUCT_RATING_DELETE_SUCCESS,
  CUSTOMER_PRODUCT_RATING_DELETE_FAILURE
} from './constants';

const INITIAL_STATE = {
  data: {},
  isFetching: false,
  error: null
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CUSTOMER_PRODUCT_RATING_LIST_REQUEST:
    case CUSTOMER_PRODUCT_RATING_LIKE_REQUEST:
    case CUSTOMER_PRODUCT_RATING_DISLIKE_REQUEST:
    case CUSTOMER_PRODUCT_RATING_DELETE_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case CUSTOMER_PRODUCT_RATING_DELETE_SUCCESS: {
      const newData = { ...state.data };
      delete newData[action.productId];
      return {
        ...state,
        isFetching: false,
        data: newData
      };
    }
    case CUSTOMER_PRODUCT_RATING_LIST_SUCCESS: {
      const arr = Array.isArray(action.payload?.data)
        ? action.payload.data
        : [];
      const ratings = arr.reduce((acc, rating) => {
        acc[rating.productId] = rating;
        return acc;
      }, {});
      return {
        ...state,
        isFetching: false,
        data: ratings
      };
    }
    case CUSTOMER_PRODUCT_RATING_LIKE_SUCCESS:
    case CUSTOMER_PRODUCT_RATING_DISLIKE_SUCCESS: {
      const rating = action.payload;
      const newData = { ...state.data };
      if (rating && (rating.productId || rating.id)) {
        const pid = rating.productId || rating.id;
        newData[pid] = rating;
      }
      return {
        ...state,
        isFetching: false,
        data: newData
      };
    }
    case CUSTOMER_PRODUCT_RATING_LIST_FAILURE:
    case CUSTOMER_PRODUCT_RATING_LIKE_FAILURE:
    case CUSTOMER_PRODUCT_RATING_DISLIKE_FAILURE:
    case CUSTOMER_PRODUCT_RATING_DELETE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    default:
      return state;
  }
};

export default reducer;
